import { Modal, Button } from "react-bootstrap";

import "./ConditionalModal.scss";
import failIcon from "../../assets/images/failIcon.svg";
import GoldIcon from "../../assets/images/gold_rupe_icon.svg";
import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../utils/context";

const ConditionalModalRequestFail = (props) => {
  const { sliderAmount } = useContext(AppContext);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600); // Adjust breakpoint as needed
    };

    // Check screen size on component mount
    handleResize();

    // Add event listener for window resize
    window.addEventListener('resize', handleResize);

    // Clean up event listener on unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered={!isMobile}
        className="conditional-modal slide-up-modal"
      >
        <Button
          type="button"
          className="custom-close mobile-close1"
          aria-label="Close"
          onClick={() => {
            props.onHide();
          }}
        >
          <span aria-hidden="true">&times;</span>
        </Button>

        <Modal.Header>
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="text-center w-100"
          ></Modal.Title>
        </Modal.Header>

        <Modal.Body className="mobile-body">
          {
            <>
              <div className="row text-center">
                <div className="col-lg-12">
                  <img src={failIcon} alt="fail icon" />
                </div>
                <h1>Point request Failed!</h1>
                <div className="modal-div">
                  <p>Your request for <span style={{fontWeight: 700}}>{sliderAmount}</span>
                  <img
                    src={GoldIcon}
                    alt="gold icon"
                    style={{ padding: 0, width: "20px" }}
                  />
                  has been failed due to insufficient balance</p>
                </div>
                <div>
                  <button className="radius0_button" data-bs-dismiss="modal" onClick={() => { props.onHide();}}>
                  Ok, Got it!
                  </button>
                </div>
              </div>
            </>
          }
        </Modal.Body>

        <Modal.Footer></Modal.Footer>
      </Modal>
    </>
  );
};

export default ConditionalModalRequestFail;
